import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import { useParams, withRouter } from 'react-router';
import LabConnectionEditService from '../service/LabConnectionEditService';

const config = data => {
	return {
		key: 'labConnectionEditForm',
		text: 'Lab Connection',
		topic: 'labConnection',
		service: LabConnectionEditService,
		fields: initData => [
			{
				key: 'name',
				component: EditFormTextField,
				required: true
			},
			{
				key: 'hostName',
				component: EditFormTextField,
				required: true
			},
			{
				key: 'databaseName',
				component: EditFormTextField,
				required: true
			},
			{
				key: 'user',
				component: EditFormTextField,
				required: true
			},
			{
				key: 'password',
				component: EditFormTextField,
				required: true,
				autoComplete: 'new-password',
				type: 'password'
			}
		]
	};
};

function LabConnectionEditForm() {
	const { id } = useParams();

	const myConfig = config({ id });
	return <EditFormPage config={myConfig} />;
}

export default withRouter(LabConnectionEditForm);
